import React, { useState } from 'react';
import { Form, Button, Container, Card, Alert, Modal, ListGroup } from 'react-bootstrap';
import ConnectionStatus from '../components/ConnectionStatus';
import EnvDebug from '../components/EnvDebug';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';

const UserLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showInstructions, setShowInstructions] = useState(false);
  const navigate = useNavigate();

  const handleContinueToShop = () => {
    // Show instructions first, then redirect
    setShowInstructions(true);
  };

  const handleDirectShopRedirect = () => {
    // Redirect directly to Shopify store
    window.location.href = 'https://littlelambsfundraising.myshopify.com';
  };
  
  // No longer need campaign selection

  // Render the main content with instructions and shop button
  const renderMainContent = () => (
    <>
      <h3 className="auth-title">Little Lambs Fundraising</h3>
      
      {error && <Alert variant="danger">{error}</Alert>}
      
      <Alert variant="info" className="mb-4">
        <h5>Welcome to Little Lambs Fundraising!</h5>
        <p>
          Click the button below to continue to our online store. You'll need to enter your 
          Group Code and Salesperson information during checkout.
        </p>
      </Alert>
      
      <div className="d-grid gap-2">
        <Button 
          variant="primary" 
          size="lg"
          onClick={handleContinueToShop}
          disabled={loading}
        >
          {loading ? 'Loading...' : 'Continue to Shop'}
        </Button>
      </div>
      
      <div className="auth-footer mt-4">
        <p>
          Coordinator? <Link to="/coordinator/login" className="auth-link">Coordinator Login</Link>
        </p>
        <p>
          Are you an administrator? <Link to="/admin/login" className="auth-link">Admin Login</Link>
        </p>
      </div>
    </>
  );
  
  // No longer need step 2
  
  return (
    <Container className="auth-container">
      <EnvDebug />
      <Card>
        <Card.Body>
          <div className="auth-logo">
            <h2>Little Lambs Fundraising Online Portal</h2>
            <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
              <ConnectionStatus />
            </div>
          </div>
          
          {renderMainContent()}
        </Card.Body>
      </Card>
      
      {/* Instructions Modal */}
      <Modal 
        show={showInstructions} 
        onHide={() => setShowInstructions(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Important Shopping Instructions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="warning" className="mb-4">
            <h5>Please Read Carefully</h5>
            <p>
              To ensure your purchases are properly credited to your fundraiser, you must enter your 
              Group Code and Salesperson Name during checkout.
            </p>
          </Alert>
          
          <Card className="mb-4">
            <Card.Header as="h5">How to Enter Your Information</Card.Header>
            <Card.Body>
              <ListGroup variant="flush" className="mb-3">
                <ListGroup.Item>
                  <strong>1.</strong> Add items to your cart
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>2.</strong> On the cart page, you will see fields to enter:
                  <ul className="mt-2">
                    <li><strong>Group Code</strong> - Enter your fundraising group code (REQUIRED)</li>
                    <li><strong>Salesperson</strong> - Enter the name of the person you are buying from (REQUIRED) - sales will count toward this person</li>                  </ul>
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>3.</strong> Fill in these fields before proceeding to checkout
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>4.</strong> Complete your purchase normally
                </ListGroup.Item>
              </ListGroup>
              
              <Alert variant="danger">
                <strong>Important:</strong> Group Code and Salesperson name are CRITICAL! 
                If you do not enter both fields correctly, your purchase will not be credited to the fundraiser.
              </Alert>
            </Card.Body>
          </Card>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowInstructions(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleDirectShopRedirect}>
            I Understand - Continue to Shop
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default UserLogin;
